import { render, staticRenderFns } from "./exam.vue?vue&type=template&id=17aadc8e&scoped=true&"
import script from "./exam.vue?vue&type=script&lang=js&"
export * from "./exam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17aadc8e",
  null
  
)

export default component.exports